import { useOidc } from '@axa-fr/react-oidc';
import { getByUsername } from '@entities/OpenIDProvider/api';
import { useEffect } from 'react';

export const useWebSocketUpdate = (userId: any, email: any) => {
    const { logout } = useOidc();
    useEffect(() => {
        const socket = new WebSocket(`wss://ria-devapi.staging.adelphis.co/ws?userId=${userId}`);

        socket.onmessage = async (message) => {
            const data = JSON.parse(message.data);
            if (data.action === 'logout') {
                localStorage.clear();
                await logout();
            }
            if (data.action === 'ReloadSession') {
                const user = await getByUsername(email);
                localStorage.setItem('User', JSON.stringify(user));
                window.location.reload();
            }
        };

        return () => {
            socket.close();
        };
    }, [userId]);
};
